import { CheckedState } from "@radix-ui/react-checkbox";
import { RandomId } from "@swivl-mono/helpers";
import { EmailTemplates, NodeInterface } from "@swivl-mono/types";
import { Checkbox, Select } from "@swivl-mono/ui";
import _ from "lodash";

import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel, { NodePanelProps } from "./NodePanel";

const Email = {
  Type: "email",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Email.Type,
      delay: 0,
      showTyping: false,
      recipients: "",
      cc: "",
      title: "",
      body: "",

      template: "none",
      onCompleteGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      label: "Email",
      title: node.title,
      body: node.recipients,
      baseWidth: 160,
      tabs: [
        {
          id: "onCompleteGoto",
          source: "onCompleteGoto",
          target: node.onCompleteGoto
        }
      ]
    });
  },

  InspectorPanel: class EmailInspectorPanel extends NodePanel {
    constructor(props: NodePanelProps) {
      super(props);
      // const showReplyTo =  (this.props.node.replyTo && this.props.node.replyTo.length > 1) ? true : false;

      this.state = { showReplyTo: false };
      this.customReplyToChecked = this.customReplyToChecked.bind(this);
      this.renderEmailBody = this.renderEmailBody.bind(this);
    }
    customReplyToChecked(checked: CheckedState) {
      let node = JSON.parse(JSON.stringify(this.props.node));

      if (checked) {
        if (!node.replyTo) {
          node.replyTo = "";
        }
      } else {
        delete node.replyTo;
      }
      this.props.updateNode(node, this.props.node);
      this.setState({ showReplyTo: checked });
    }

    renderEmailBody() {
      const template = this.props.node.template;
      if (!template || !template.length || template === "none") {
        return (
          <div className="emailInput">
            <TagInput label="EMAIL BODY" value={this.props.node.body} onChange={this.onChange} name="body" placeholder="Body..." />
          </div>
        );
      } else {
        const templateData = EmailTemplates.find((t) => {
          return t.name === template;
        });
        if (!templateData) {
          return null;
        }
        const nodeMergeFields = this.props.node.mergeFields || {};

        var items: any = [];
        _.forOwn(templateData.mergeFields, (field, key) => {
          const fieldValue = typeof nodeMergeFields[key] === "string" ? nodeMergeFields[key] : field.defaultVariableOrValue;

          items.push(
            <TagInput
              label={field.displayName}
              value={fieldValue}
              onChange={this.onChange}
              name={`mergeFields.${key}`}
              placeholder={`${field.displayName}...`}
              type={TagInputType.SingleLine}
            />
          );
        });
        return items;
      }
    }

    render() {
      const useCustomReplyTo = (this.state as any).showReplyTo || (this.props.node.replyTo && this.props.node.replyTo.length > 1) ? true : false;

      const replyToInput = !useCustomReplyTo ? null : (
        <TagInput type={TagInputType.SingleLine} value={this.props.node.replyTo} onChange={this.onChange} name="replyTo" placeholder="Reply to..." />
      );
      const replyToCheckbox = (
        <div className="replyToCheckbox emailInput">
          <span>Custom Reply To</span>
          <span style={{ float: "right" }}>
            <Checkbox onCheckedChange={this.customReplyToChecked} name="openLinksInNewTab" checked={useCustomReplyTo} />
          </span>
          {replyToInput}
        </div>
      );

      return (
        <div>
          <div className="panel email_panel">
            <InspectorNodeHeader title="Email" />
            <TagInput
              label="RECIPIENTS"
              helperText="Separate by comma"
              value={this.props.node.recipients}
              onChange={this.onChange}
              name="recipients"
              placeholder="Recipients..."
            />
            <br />
            <Checkbox onCheckedChange={this.onChange} label="CC Recipients" name="preserveRecipients" checked={this.props.node.preserveRecipients} />
            <br />

            <TagInput
              label="EMAIL SUBJECT"
              value={this.props.node.title}
              onChange={this.onChange}
              name="title"
              placeholder="Subject..."
              type={TagInputType.SingleLine}
            />

            <Select
              label="Template"
              options={[{ value: "none", label: "None" }].concat(
                EmailTemplates.map((t) => ({
                  value: t.name,
                  label: t.templateDisplayName
                }))
              )}
              selectedValues={[this.props.node.template || "none"]}
              hideClear
              onChange={(vals) => this.onChangeSwitch("template", vals[0])}
            />
            {this.renderEmailBody()}
            <br />
            <div className="variableInfo">To add a variable, type #</div>
            {replyToCheckbox}
          </div>
          <br />
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default Email;
